import http from "@/http/aisea/axios";
const resource = "/voyage_records";

export default {
  // 自船位置取得（旧: GET /enterprise/voyage/histories/points/vessels/{id}）
  fetchVesselPoints(vesselId, params) {
    return http.get(`${resource}/vessels/${vesselId}`, {
      params: params,
    });
  },
  // 他船位置取得（旧: GET /voyage_history/location_search）
  searchVesselsPoints(params) {
    return http.get(`${resource}/vessels/search`, {
      params: params,
    });
  },
};
